<template>
    <div class="pa-3">
        <div class="text-h6"><u>Finances du module</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Total CB sans taxes</div>
            <div class="text-h6 font-weight-bold">{{ finances.module_total_cb_without_taxes }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total taxes</div>
            <div class="text-h6 font-weight-bold">{{ finances.module_total_taxes }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total CB avec taxes</div>
            <div class="text-h6 font-weight-bold">{{ finances.module_total_cb_with_taxes }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Finances des inscrits</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre d'inscriptions</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total CB</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total }}€</div>
        </div>


        <div class="d-flex justify-space-between align-center">
            <div>Total inscriptions</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total_inscription }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total options/activités/boutique</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total_options }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total options</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total_details_options }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total activités</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total_details_activites }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total articles</div>
            <div class="text-h6 font-weight-bold">{{ finances.booking_total_details_articles }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Finances des ventes en bourse</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de ventes</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total CB</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total inscriptions</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total_inscription }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total options/activités/boutique</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total_options }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total options</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total_details_options }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total activités</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total_details_activites }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Détails Total articles</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total_details_articles }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Demandes de paiements</u></div>
        <div class="text-subtitle-2 text-grey-darken-2">Ces paiements sont intégrés dans les totaux des inscrits</div>
        <div class="d-flex justify-space-between align-center">
            <div>Paiements sportif</div>
            <div class="text-h6 font-weight-bold">{{ finances.payment_requests_total_sportif }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Paiements option</div>
            <div class="text-h6 font-weight-bold">{{ finances.payment_requests_total_option }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Dons</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Total dons</div>
            <div class="text-h6 font-weight-bold">{{ finances.don_total }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>GIA</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de GIA</div>
            <div class="text-h6 font-weight-bold">{{ finances.gia_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total GIA</div>
            <div class="text-h6 font-weight-bold">{{ finances.gia_total }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Alertes SMS</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre d'alertes SMS</div>
            <div class="text-h6 font-weight-bold">{{ finances.alerte_sms_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total alertes SMS</div>
            <div class="text-h6 font-weight-bold">{{ finances.alerte_sms_total }}€</div>
        </div>

        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Remboursements</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de remboursements</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de remboursements organisateurs</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_nb_orga }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total remboursements organisateurs</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_total_orga }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Frais de remboursements organisateurs</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_total_frais }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de remboursements Sportips GIA</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_nb_sportips }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total remboursements Sportips GIA</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_total_sportips }}€</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de remboursements Sportips Bourse</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_nb_bourse_dossard }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total remboursements Sportips Bourse</div>
            <div class="text-h6 font-weight-bold">{{ finances.refunds_total_bourse_dossard }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Bourse aux dossards</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de dossards vendus</div>
            <div class="text-h6 font-weight-bold">{{ finances.bourse_dossards_nb_vente }}</div>

        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total frais acheteurs</div>
            <div class="text-h6 font-weight-bold">{{ finances.bourse_dossard_total_frais_acheteur }}€</div>
        </div>
        <div class="text-subtitle-2 text-grey-darken-2">Les frais vendeurs peuvent être éronnés si des remboursements
            sont en attente</div>
        <div class="d-flex justify-space-between align-center">
            <div>Total frais vendeurs</div>
            <div class="text-h6 font-weight-bold">{{ finances.bookingsold_total - finances.refunds_total_bourse_dossard
            }}€</div>
        </div>
        <v-divider style="margin: 5px 0 !important"></v-divider>
        <div class="text-h6"><u>Crédits perdus</u></div>
        <div class="d-flex justify-space-between align-center">
            <div>Nombre de crédits perdus</div>
            <div class="text-h6 font-weight-bold">{{ finances.lost_credits_nb }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>Total crédits perdus</div>
            <div class="text-h6 font-weight-bold">{{ finances.lost_credits_total }}€</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['finances']
}
</script>

<style lang="scss" scoped></style>